import React from 'react';
import PropTypes from 'prop-types';

import MUISwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Box from 'components/atoms/Box/Box';

import { useDrawerStyles } from './drawerStyles';

export default function Drawer(props) {
  const { children, ...rest } = props;
  const classes = useDrawerStyles(props);

  return (
    <Box>
      <MUISwipeableDrawer
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        {...rest}
      >
        {children}
      </MUISwipeableDrawer>
    </Box>
  );
}

Drawer.propTypes = {
  /** Drawer width */
  drawerWidth: PropTypes.string.isRequired,
  /** Drawer anchor */
  anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  /** Drawer variant */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary']),
  /** If true drawer is opened */
  open: PropTypes.bool,
  /** Callback fired when the component requests to be closed.

    Signature:
    function(event: object) => void
    event: The event source of the callback*/
  onClose: PropTypes.func,
  /** Paper background color */
  backgroundColor: PropTypes.string,
};
